import { render, staticRenderFns } from "./ModalForward.vue?vue&type=template&id=99f9f2aa&scoped=true"
import script from "./ModalForward.vue?vue&type=script&lang=js"
export * from "./ModalForward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f9f2aa",
  null
  
)

export default component.exports